module.exports = __webpack_public_path__ + "img/u382.919c29ff.png";